module.exports = __webpack_public_path__ + "img/ccqy.0142b3ad.png";